import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from 'atoms';

const Card = styled(Box)`
	background: #fff;
	border-radius: 8px;
	border-top: 2px solid #2f8ecb;
	padding: 24px;
`;
const HeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
`;
const PayTable = styled.table`
	width: 100%;
	border-collapse: collapse;
`;
const Row = styled.tr`
	border: 1px solid #ddd;
`;
const Cell = styled.td`
	border: 1px solid #ddd;
	padding: 12px;
	width: 50%;
	background: ${(p) => (p.isTotal ? '#143e60' : '#fff')};
	color: ${(p) => (p.isTotal ? '#fff' : '#333')};
	font-weight: ${(p) => (p.isTotal ? 600 : 400)};
`;

const formatCurrency = (value) =>
	`₹ ${(Number(value) || 0).toLocaleString('en-IN', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;

/**
 * Static client-invoice charges summary (Subtotal / GST / TDS / Customer Debit /
 * Grand Total). AR mirror of the vendor TotalPayable display.
 */
function EditablePayableChargesV2({ invoice }) {
	const subtotal = Number(invoice?.subtotal || 0);
	const gst =
		Number(invoice?.cgst_amount || 0) +
		Number(invoice?.sgst_amount || 0) +
		Number(invoice?.igst_amount || 0);

	return (
		<Card mt="20px">
			<HeaderRow>
				<Text style={{ fontSize: 18, fontWeight: 600 }}>Total Payable</Text>
			</HeaderRow>

			<PayTable>
				<tbody>
					<Row>
						<Cell>Subtotal :</Cell>
						<Cell>{formatCurrency(subtotal)}</Cell>
					</Row>
					<Row>
						<Cell>GST :</Cell>
						<Cell>{formatCurrency(gst)}</Cell>
					</Row>
					<Row>
						<Cell isTotal>Grand Total :</Cell>
						<Cell isTotal>{formatCurrency(invoice?.grand_total)}</Cell>
					</Row>
				</tbody>
			</PayTable>
		</Card>
	);
}

EditablePayableChargesV2.propTypes = {
	invoice: PropTypes.object,
};

export default EditablePayableChargesV2;
